import devLogo from "../assets/dev-logo.webp";
import liveLogo from "../assets/live-logo.webp";

// Live build (meridian) uses the live logo, dev build (sunsolv) uses the dev logo.
// The comparison is written against import.meta.env directly so Vite can inline it
// and drop the unused logo from the bundle at build time.
export const APP_LOGO =
  import.meta.env.VITE_APP_ENV === "production" ? liveLogo : devLogo;
